import React, { useEffect } from 'react'
import { img_path } from '../../../../../environment'
import ImageWithBasePath from '../../../../../core/common/imageWithBasePath'
import { Link } from 'react-router-dom'
import dayjs from 'dayjs';
import DateComp from '../../../../../core/common/dateComponent/DateComp';


const FirstAptTicket = ({ getFirstAptTicket, targetRef,onRenderReady }: any) => {
    const newDate = Date.now()
    const formattedDate = dayjs(newDate).format('YYYY-MM-DD HH:mm:ss');

    useEffect(() => {
        if (getFirstAptTicket) {
            onRenderReady?.();
        }
    }, [getFirstAptTicket]);
    
    return (
        <div className='row' ref={targetRef} id='fist_Apt_Ticket' style={{ pageBreakAfter: "always" }}>
            <div className='col-md-12 px-5'>
                <div className='d-flex gap-2 align-items-center'>
                    <div>
                        <ImageWithBasePath
                            src="assets/img/logo.svg"
                            className=""
                            alt="Logo"
                            width={120}
                            height={68}
                        />
                    </div>
                    <div className='mt-2 fs-12'>
                        <p className='mb-0'>
                            <b>AIROOM, LLC</b>
                            <br />
                            <b>
                                Address {" "}
                            </b>
                            6825 N. Lincoln Ave., Lincolnwood, IL 60712  <br />
                            <b> BRANCH OFFICE</b> 36 S. Washington, Hinsdale, IL  60521
                        </p>
                        <p>
                            Phone: 847-763-1100  - 847.763.1101  - <Link to="https:/www.airoom.com" className='text-decoration-underline text-primary'>www.airoom.com</Link>
                        </p>
                    </div>
                </div>
                <h4 className='mt-3 mb-3'>First Appointment Ticket for {getFirstAptTicket?.result?.contacts?.primaryContactVMs?.firstName} {getFirstAptTicket?.result?.contacts?.primaryContactVMs?.lastName}
                    {' '}   {getFirstAptTicket?.result?.contacts?.secondaryContactVMs?.firstName ? '&' : ''} {getFirstAptTicket?.result?.contacts?.secondaryContactVMs?.firstName} {getFirstAptTicket?.result?.contacts?.secondaryContactVMs?.lastName}
                </h4>
                <p className='mb-1'>
                    Opportunity Created Date : <DateComp formattedDate={getFirstAptTicket?.result?.opportunityCreatedDate} />

                </p>
                <div className='border bg-darkgray'>
                    <div className='row'>
                        <div className='col-md-6' style={{ flex: '0 0 50%', maxWidth: '50%' }}>
                            <div className='d-flex'>
                                <p className='w-35 mb-0'>
                                    1st Contact Date:
                                </p>
                                <p className='mb-0'>
                                    <DateComp formattedDate={getFirstAptTicket?.result?.leadSource?.firstContactDate} />
                                </p>
                            </div>
                            <div className='d-flex'>
                                <p className='w-35 mb-0'>
                                    Inquiry Method:
                                </p>
                                <p className='mb-0'>
                                    {getFirstAptTicket?.result?.leadSource?.lst_MethodOfInquiry?.value}

                                </p>
                            </div>
                        </div>
                        <div className='col-md-6' style={{ flex: '0 0 50%', maxWidth: '50%' }}>
                            <div className='d-flex'>
                                <p className='w-35 mb-0'>
                                    Source:
                                </p>
                                <p className='mb-0'>
                                    {getFirstAptTicket?.result?.leadSource?.lst_LeadSource?.value}

                                </p>
                            </div>
                            <div className='d-flex'>
                                <p className='w-35 mb-0'>
                                    Source Desription:
                                </p>
                                <p className='mb-0'>
                                    {getFirstAptTicket?.result?.leadSource?.sourceDescription}

                                </p>
                            </div>
                            <div className='d-flex'>
                                <p className='w-35 mb-0'>
                                    Ad Code:
                                </p>
                                <p className='mb-0'>
                                    {getFirstAptTicket?.result?.leadSource?.adCode}

                                </p>
                            </div>
                        </div>

                    </div>
                </div>
                <div className='border bg-gray mt-2'>
                    <div className='row'>
                        <h6 className='mb-2'>CLIENT INFORMATION</h6>
                        <div className='d-flex align-items-center'>
                            <h6>Property Address:</h6>
                            <p className='mb-0 ms-2'>{getFirstAptTicket?.result?.contacts?.primaryContactVMs?.propertyAddress?.addressLine1}</p>
                        </div>
                        <div className='col-md-6 mt-2' style={{ flex: '0 0 50%', maxWidth: '50%' }}>
                            <div className='d-flex'>
                                <h6>Primary Contact:</h6>
                                <h6 className='ms-2'>{getFirstAptTicket?.result?.contacts?.primaryContactVMs?.firstName} {getFirstAptTicket?.result?.contacts?.primaryContactVMs?.lastName}</h6>
                            </div>
                            <div className='d-flex'>
                                <p className='w-25 mb-0'>
                                    Home Phone:
                                </p>
                                <p className='mb-0'>
                                    {getFirstAptTicket?.result?.contacts?.primaryContactVMs?.homePhone}

                                </p>
                            </div>
                            <div className='d-flex'>
                                <p className='w-25 mb-0'>
                                    Work Phone:
                                </p>
                                <p className='mb-0'>
                                    {getFirstAptTicket?.result?.contacts?.primaryContactVMs?.workPhone}

                                </p>
                            </div>
                            <div className='d-flex'>
                                <p className='w-25 mb-0'>
                                    Cell Phone:
                                </p>
                                <p className='mb-0'>
                                    {getFirstAptTicket?.result?.contacts?.primaryContactVMs?.cellPhone}

                                </p>
                            </div>
                            <div className='d-flex'>
                                <p className='w-25 mb-0'>
                                    Pager:
                                </p>
                                <p className='mb-0'>
                                    {getFirstAptTicket?.result?.contacts?.primaryContactVMs?.pager}
                                </p>
                            </div>
                            <div className='d-flex'>
                                <p className='w-25 mb-0'>
                                    Home Email:
                                </p>
                                <p className='mb-0'>
                                    {getFirstAptTicket?.result?.contacts?.primaryContactVMs?.homeEmail}

                                </p>
                            </div>
                            <div className='d-flex'>
                                <p className='w-25 mb-0'>
                                    Work Email:
                                </p>
                                <p className='mb-0'>
                                    {getFirstAptTicket?.result?.contacts?.primaryContactVMs?.workEmail}

                                </p>
                            </div>
                            <div className='d-flex'>
                                <p className='w-25 mb-0'>
                                    Pref Method:
                                </p>
                                <p className='mb-0'>
                                    {getFirstAptTicket?.result?.contacts?.primaryContactVMs?.preferredMethod?.name}

                                </p>
                            </div>
                            <div className='d-flex'>
                                <p className='w-25 mb-0'>
                                    Pref Times:
                                </p>
                                <p className='mb-0'>
                                    {getFirstAptTicket?.result?.contacts?.primaryContactVMs?.perferredTime}

                                </p>
                            </div>
                        </div>
                        <div className='col-md-6 mt-2' style={{ flex: '0 0 50%', maxWidth: '50%' }}>
                            <div className='d-flex'>
                                <h6>Secondary Contact:</h6>
                                <h6 className='ms-2'>{getFirstAptTicket?.result?.contacts?.secondaryContactVMs?.firstName} {getFirstAptTicket?.result?.contacts?.secondaryContactVMs?.lastName}</h6>
                            </div>
                            <div className='d-flex'>
                                <p className='w-25 mb-0'>
                                    Home Phone:
                                </p>
                                <p className='mb-0'>
                                    {getFirstAptTicket?.result?.contacts?.secondaryContactVMs?.homePhone}

                                </p>
                            </div>
                            <div className='d-flex'>
                                <p className='w-25 mb-0'>
                                    Work Phone:
                                </p>
                                <p className='mb-0'>
                                    {getFirstAptTicket?.result?.contacts?.secondaryContactVMs?.workPhone}

                                </p>
                            </div>
                            <div className='d-flex'>
                                <p className='w-25 mb-0'>
                                    Cell Phone:
                                </p>
                                <p className='mb-0'>
                                    {getFirstAptTicket?.result?.contacts?.secondaryContactVMs?.cellPhone}

                                </p>
                            </div>
                            <div className='d-flex'>
                                <p className='w-25 mb-0'>
                                    Pager:
                                </p>
                                <p className='mb-0'>
                                    {getFirstAptTicket?.result?.contacts?.secondaryContactVMs?.pager}
                                </p>
                            </div>
                            <div className='d-flex'>
                                <p className='w-25 mb-0'>
                                    Home Email:
                                </p>
                                <p className='mb-0'>
                                    {getFirstAptTicket?.result?.contacts?.secondaryContactVMs?.homeEmail}

                                </p>
                            </div>
                            <div className='d-flex'>
                                <p className='w-25 mb-0'>
                                    Work Email:
                                </p>
                                <p className='mb-0'>
                                    {getFirstAptTicket?.result?.contacts?.secondaryContactVMs?.email}

                                </p>
                            </div>
                            <div className='d-flex'>
                                <p className='w-25 mb-0'>
                                    Pref Method:
                                </p>
                                <p className='mb-0'>
                                    {getFirstAptTicket?.result?.contacts?.secondaryContactVMs?.preferredMethod?.name}

                                </p>
                            </div>
                            <div className='d-flex'>
                                <p className='w-25 mb-0'>
                                    Pref Times:
                                </p>
                                <p className='mb-0'>
                                    {getFirstAptTicket?.result?.contacts?.secondaryContactVMs?.perferredTime}

                                </p>
                            </div>
                        </div>

                    </div>
                </div>
                <div className='border bg-darkgray mt-2'>
                    <div className='row'>
                        <h6>APPT INFORMATION</h6>
                        <div className='col-md-6' style={{ flex: '0 0 50%', maxWidth: '50%' }}>
                            <div className='d-flex'>
                                <p className='w-25 mb-0'>
                                    First Appt:
                                </p>
                                <p className='mb-0'>
                                    <DateComp formattedDate={getFirstAptTicket?.result?.appointmentDetails?.firstAptDate} />
                                </p>
                            </div>
                            <div className='d-flex'>
                                <p className='w-25 mb-0'>
                                    Appt Maker:
                                </p>
                                <p className='mb-0'>
                                    {getFirstAptTicket?.result?.appointmentDetails?.appointmentMaker?.value}

                                </p>
                            </div>
                        </div>
                        <div className='col-md-6' style={{ flex: '0 0 50%', maxWidth: '50%' }}>
                            <div className='d-flex'>
                                <p className='w-25 mb-0'>
                                </p>
                                <p className='mb-0'>

                                </p>
                            </div>
                            <div className='d-flex'>
                                <p className='w-25 mb-0'>
                                    PDM:
                                </p>
                                <p className='mb-0'>
                                    {getFirstAptTicket?.result?.pdm}
                                </p>
                            </div>
                        </div>

                    </div>
                </div>
                <h5 className='mb-2 mt-2'>
                    PROJECT INFORMATION
                </h5>

                <div className='d-flex'>
                    <p className='mb-0'>
                        Job Type:
                    </p>
                    <p className='mb-0 ms-2'>
                        {getFirstAptTicket?.result?.jobType}
                    </p>
                </div>
                <div className='d-flex'>
                    <p className='mb-0'>
                        Job Desc:
                    </p>
                    <p className='mb-0 ms-2'>
                        {getFirstAptTicket?.result?.jobDescription}
                    </p>
                </div>
                <p className='mt-2 mb-0 text-decoration-underline fw-600'>
                    General Background
                </p>
                <div className='ms-4'>
                    <ul className='custom-ul'>
                        {getFirstAptTicket?.result?.oppertunityDetails?.generalBackground?.map((item: any, index: any) => (
                            <li key={index}>
                                {item.name}: {item.surveyResultOriginal === "1" ? '' : item.surveyResultOriginal || ''}
                            </li>
                        ))}
                    </ul>
                </div>
                <p className='mt-2 mb-2 text-decoration-underline fw-600'>
                    Clients' Past Home Renovation Experience
                </p>
                <div className='ms-4'>
                    <ul className='custom-ul'>
                        {getFirstAptTicket?.result?.oppertunityDetails?.clientpastHomeRenvExp?.map((item: any, index: any) => (
                            <li key={index}>
                                {item.name}: {item.surveyResultOriginal === "1" ? '' : item.surveyResultOriginal || ''}
                            </li>
                        ))}
                    </ul>
                </div>
                <p className='mt-2 mb-0 text-decoration-underline fw-600'>
                    Clients' Reason for Project
                </p>
                <div className='ms-4'>
                    <ul className='custom-ul'>
                        {getFirstAptTicket?.result?.oppertunityDetails?.clientReasonForProject?.map((item: any, index: any) => (
                            <li key={index}>
                                {item.name}: {item.surveyResultOriginal === "1" ? '' : item.surveyResultOriginal || ''}
                            </li>
                        ))}
                    </ul>
                </div>
                <p className='mt-2 mb-0 text-decoration-underline fw-600'>
                    Project Background
                </p>
                <div className='ms-4'>
                    <ul className='custom-ul'>
                        {getFirstAptTicket?.result?.oppertunityDetails?.projectBackground?.map((item: any, index: any) => (
                            <li key={index}>
                                {item.name}: {item.surveyResultOriginal === "1" ? '' : item.surveyResultOriginal || ''}
                            </li>
                        ))}
                    </ul>
                </div>
                <p className='mt-2 mb-0 text-decoration-underline fw-600'>
                    Opportunity Scope
                </p>
                <div className='ms-4'>
                    <ul className='custom-ul'>
                        {getFirstAptTicket?.result?.oppertunityDetailScope?.opportunityScop?.map((item: any, index: any) => (
                            <li key={index}>
                                {item.name}: {item.surveyResultOriginal === "1" ? '' : item.surveyResultOriginal || ''}
                            </li>
                        ))}
                    </ul>
                </div>
                <p className='mt-2 mb-0 text-decoration-underline fw-600'>
                    Additional Scope
                </p>
                <div className='ms-4'>
                    <ul className='custom-ul'>
                        {getFirstAptTicket?.result?.oppertunityDetailScope?.additionScope?.map((item: any, index: any) => (
                            <li key={index}>
                                {item.name}: {item.surveyResultOriginal === "1" ? '' : item.surveyResultOriginal || ''}
                            </li>
                        ))}
                    </ul>
                </div>
                <p className='mt-2 mb-0 text-decoration-underline fw-600'>
                    Detailed Scope
                </p>
                <div className='ms-4'>
                    <ul className='custom-ul'>
                        {getFirstAptTicket?.result?.oppertunityDetailScope?.detailedScope?.map((item: any, index: any) => (
                            <li key={index}>
                                {item.name}: {item.surveyResultOriginal === "1" ? '' : item.surveyResultOriginal || ''}
                            </li>
                        ))}
                    </ul>
                </div>
                <h5 className='mt-4'>
                    Notes
                </h5>
                <p className='mt-2'>

                </p>
            </div>
        </div>
    )
}

export default FirstAptTicket